module.exports = __webpack_public_path__ + "img/545B4D_D8DDC8_A0A792_B2C1A3-256px.8a3ba9d7.png";